/**
 * 애플리케이션 내에서 발생한 오류를 표시하는 컴포넌트
 * 
 * 이 컴포넌트는 Material UI의 Alert 컴포넌트를 기반으로 한 일관된 오류 메시지 UI를 제공합니다.
 * 문자열 메시지, 오류 객체, 재시도 기능을 지원하여 다양한 오류 상황에 대응할 수 있습니다.
 * 
 * @param {Object} props
 * @param {string} [props.title='오류가 발생했습니다'] - 오류 메시지의 제목
 * @param {string|Error|Object} props.message - 표시할 오류 메시지 또는 오류 객체
 * @param {Function} [props.onRetry] - 재시도 버튼 클릭 시 호출될 함수 (제공되지 않으면 버튼 미표시)
 * 
 * @example
 * // 문자열 메시지
 * <ErrorMessage message="서버 연결에 실패했습니다." />
 * 
 * // 오류 객체
 * <ErrorMessage message={new Error("API 호출 중 오류가 발생했습니다")} />
 * 
 * // 재시도 기능 포함
 * <ErrorMessage 
 *   title="데이터 로드 실패"
 *   message="네트워크 오류가 발생했습니다."
 *   onRetry={() => fetchData()}
 * />
 */

import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

const ErrorMessage = ({ title = '오류가 발생했습니다', message, onRetry }) => {
  let text = '';
  if (typeof message === 'string') {
    text = message;
  } else if (message && typeof message === 'object') {
    text = message.message || JSON.stringify(message);
  } else {
    text = '알 수 없는 오류가 발생했습니다. 다시 시도해 주세요.';
  }
  return (
    <Box sx={{ my: 2 }}>
      <Alert severity="error">
        <AlertTitle>{title}</AlertTitle>
        {text}
        {onRetry && (
          <Button
            color="error"
            size="small"
            onClick={onRetry}
            sx={{ mt: 1 }}
          >
            다시 시도
          </Button>
        )}
      </Alert>
    </Box>
  );
};

export default ErrorMessage; 